import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import mmenu from 'mmenu-js';



document.addEventListener(
    "DOMContentLoaded", () => {
        if (document.querySelector('#my-menu')) {

            /* mobile */
            new Mmenu( "#my-menu", {               
                searchfield : {
                    submit: true, 
                    placeholder   : "Bitte Suchbegriff eingeben...",
                    search: false,
                },
                "navbars": [
                    {
                       "position": "top",
                       "content": [
                          "<a class='menulogo' href='/'></a>",
                          "searchfield",
                          "close"
                        ]
                    }
                 ],
                "extensions": [
                    /* "fullscreen",
                    "popup" */
                   "position-front",
                   "position-right"
                ],
                "setSelected": {
                    "parent": true
                 }           
            },{
				language: 'de',
                searchfield: {
                    submit: true, 
                    // searchfield configuration
                    form: {
                        "action": "/suche?tx_indexedsearch_pi2%5Baction%5D=search&tx_indexedsearch_pi2%5Bcontroller%5D=Search&cHash=a374fb3fb6600edb09ed1ad16ee7ed40",
                        "method": "post",
                        "controller": "Search",
                        "extensionName": "indexedsearch",
                        "pluginName": "pi1",
                        "pageUid": "162"
                    },
                    input: {
                        "name": "tx_indexedsearch_pi2[search][sword]"
                    }
                }
            });


            /* desktop */
            new Mmenu( "#my-menu-desktop", {
				language: 'de',
                columns: {
                    add:true,
                    visible: {                      
                        max:3,
                        min:3
                    }
                },
                searchfield : {
                    submit: true, 
                    placeholder   : "Bitte Suchbegriff eingeben...",
                    search: false,
                },
                "navbars": [
                    {
                       "position": "top",
                       "content": [
                          "<a class='menulogo' href='/'></a>",
                          "searchfield",
                          "close"
                        ]
                    }
                 ],
                "extensions": [
                    /* "fullscreen",
                    "popup" */
                    "position-front",
                    "position-right"
                ],
                "setSelected": {
                    "parent": true
                }
                } ,{
					language: 'de',
                    searchfield: {
                        submit: true, 
                        // searchfield configuration
                        form: {
                            "action": "/suche?tx_indexedsearch_pi2%5Baction%5D=search&tx_indexedsearch_pi2%5Bcontroller%5D=Search&cHash=a374fb3fb6600edb09ed1ad16ee7ed40",
                            "method": "post",
                            "controller": "Search",
                            "extensionName": "indexedsearch",
                            "pluginName": "pi1",
                            "pageUid": "162"
                        },
                        input: {
                            "name": "tx_indexedsearch_pi2[search][sword]"
                        }
                    }
                }               
                );

        }        

        mmenuSwitcher();

    }
);


function mmenuSwitcher() {
  if($(this).width() < 1400) {
    $('div.mainmenu > a.item.mm-menubtn').attr('href', '#my-menu');
  }
  else {
    $('div.mainmenu > a.item.mm-menubtn').attr('href', '#my-menu-desktop');
  }
}

$(window).on('resize', mmenuSwitcher);








